<script setup lang="ts">
import { computed, watch, onBeforeUnmount } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import { useAuthStore } from './stores/auth';
import { useNotificationsStore } from './stores/notifications';
import BottomNav from './components/BottomNav.vue';
import DemoBanner from './components/DemoBanner.vue';

const route = useRoute();
const auth = useAuthStore();
const notifs = useNotificationsStore();

// Lifecycle polling notifications : demarre quand un user est connecte,
// stop des qu'il logout. Le polling lui-meme met en pause si l'onglet
// est masque (cf useNotificationsStore.startPolling()).
watch(
  () => !!auth.user,
  (loggedIn) => {
    if (loggedIn) notifs.startPolling();
    else notifs.stopPolling();
  },
  { immediate: true },
);

onBeforeUnmount(() => notifs.stopPolling());

/**
 * La BottomNav est cachee :
 *   - sur l'ecran de login (l'utilisateur n'est pas encore authentifie)
 *   - sur les ecrans plein-ecran type ChantierQrView (affichage tablette
 *     dedie pour le QR, pas besoin de chrome).
 */
const showBottomNav = computed(() => {
  if (!auth.user) return false;
  const name = String(route.name ?? '');
  if (name === 'login' || name === 'chantier-qr' || name === 'pointage-scan') return false;
  return true;
});
</script>

<template>
  <DemoBanner />
  <!-- Wrapper avec padding-bottom = hauteur BottomNav + safe-area iOS.
       Garantit qu'aucun contenu de view n'est cache derriere la nav sur mobile.
       Cache >= lg car la BottomNav elle-meme est cachee. -->
  <div :class="['min-h-screen', showBottomNav && 'pb-nav-mobile lg:pb-0']">
    <RouterView />
  </div>
  <BottomNav v-if="showBottomNav" />
</template>

<style>
.pb-nav-mobile {
  /* BottomNav fait min-h 56px + safe-area iOS. On reserve 80px pour
     garantir un confort visuel (au moins 24px d'air sous le dernier
     contenu cliquable avant la nav). */
  padding-bottom: calc(80px + env(safe-area-inset-bottom, 0));
}
</style>
